import type { StoryBadge } from "../types";

/** Original category-keyed badge colors (CSS vars defined in global.css). */
const CATEGORY_COLORS: Record<string, string> = {
  video:
    "bg-[var(--explore-category-video-bg)] text-[var(--explore-category-video-text)]",
  image:
    "bg-[var(--explore-category-image-bg)] text-[var(--explore-category-image-text)]",
  audio:
    "bg-[var(--explore-category-audio-bg)] text-[var(--explore-category-audio-text)]",
  text: "bg-[var(--explore-category-text-bg)] text-[var(--explore-category-text-text)]",
  "3d": "bg-[var(--explore-category-3d-bg)] text-[var(--explore-category-3d-text)]",
};

const FALLBACK_CATEGORY_STYLE =
  "bg-[var(--explore-accent-secondary)] text-[var(--explore-text-primary)]";

/** Get category badge style by slug, with fallback for unknown categories. */
export function getCategoryBadgeStyle(categorySlug: string | null): string {
  if (!categorySlug) {
    return FALLBACK_CATEGORY_STYLE;
  }
  return CATEGORY_COLORS[categorySlug] ?? FALLBACK_CATEGORY_STYLE;
}

/** Badge styles keyed by StoryBadge (derived from materialType + lifecycle). */
export const STORY_BADGE_STYLES: Record<StoryBadge, string> = {
  story:
    "bg-[var(--explore-badge-story-bg)] text-[var(--explore-badge-story-text)]",
  breaking:
    "bg-[var(--explore-badge-breaking-bg)] text-[var(--explore-badge-breaking-text)]",
  workflow:
    "bg-[var(--explore-badge-workflow-bg)] text-[var(--explore-badge-workflow-text)]",
  prompt:
    "bg-[var(--explore-badge-prompt-bg)] text-[var(--explore-badge-prompt-text)]",
  release:
    "bg-[var(--explore-badge-release-bg)] text-[var(--explore-badge-release-text)]",
  update:
    "bg-[var(--explore-badge-story-bg)] text-[var(--explore-badge-story-text)]",
  deal: "bg-[var(--explore-badge-deal-bg)] text-[var(--explore-badge-deal-text)]",
};
